import React from 'react';

import Link from '../../../components/Link/Link';
import { SuccessBadge } from '../../../components/Badge';
import type { TMenuLink } from 'types/TMenuLink';

const getFormattedMenuLinks = (options: TMenuLink[]) =>
  options
    .filter(({ show }) => !!show)
    .map(({ text, url, role, label, description, desktopOnlyLabel = false }) => ({
      value: text,
      label: (
        <Link
          href={url}
          data-role={`mymp-${role}`}
          tabIndex={0}
          className="a11y-text-underline"
          style={{ display: 'flex', alignItems: 'center' }}
        >
          {text}
          {label && (
            <SuccessBadge className={desktopOnlyLabel ? 'hz-hide-lte-md' : ''} utilities={['marginLeftXxxs']}>
              {label}
            </SuccessBadge>
          )}
          {description && <span className="hz-Nav-pill-link-description">{description}</span>}
        </Link>
      ),
    }));

export default getFormattedMenuLinks;
